import { CapacitorException, ExceptionCode, WebPlugin } from '@capacitor/core';
export class AppReviewWeb extends WebPlugin {
    async openAppStore() {
        throw this.createUnimplementedException();
    }
    async requestReview() {
        throw this.createUnimplementedException();
    }
    createUnimplementedException() {
        return new CapacitorException('This plugin method is not implemented on this platform.', ExceptionCode.Unimplemented);
    }
}
//# sourceMappingURL=web.js.map